import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import integrationFile from "../../../assets/markDownFiles/integration_process.md";
import Icon from "../../icon/Icon";

const GeoIntegrationProcess = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (
      typeof integrationFile === "string" &&
      integrationFile.startsWith("/static")
    ) {
      fetch(integrationFile)
        .then((res) => res.text())
        .then((raw) => {
          console.log(JSON.stringify(raw.slice(0, 200))); // log the actual fetched text
          setContent(convertMdxToMd(raw));
        });
    } else {
      console.log(JSON.stringify(integrationFile.slice(0, 200)));
      setContent(convertMdxToMd(integrationFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        Get Started
      </Typography>
      {content ? (
        <MarkdownRenderer
          content={content}
          components={{
            Icon,
          }}
        />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default GeoIntegrationProcess;
